var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluentEmojiHighContrastWhiteExclamationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 16.6658C11.0774 17.1946 11.2978 17.6967 11.677 18.0655C12.0563 18.4343 12.5644 18.6407 13.0934 18.6408C13.6223 18.6409 14.1305 18.4348 14.5099 18.0661C14.8893 17.6975 15.1099 17.1954 15.125 16.6666V3.6455C15.11 3.11673 14.8895 2.61463 14.5102 2.2459C14.1309 1.87718 13.6227 1.6709 13.0938 1.6709C12.5648 1.6709 12.0566 1.87718 11.6773 2.2459C11.298 2.61463 11.0775 3.11673 11.0625 3.6455V16.6658ZM11.0625 22.3436C11.0625 23.4608 11.9766 24.3748 13.0938 24.3748C14.2109 24.3748 15.125 23.4608 15.125 22.3436C15.125 21.2264 14.2109 20.3123 13.0938 20.3123C12.5556 20.314 12.0399 20.5286 11.6593 20.9092C11.2788 21.2897 11.0642 21.8054 11.0625 22.3436Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiHighContrastWhiteExclamationMark);
export default __webpack_public_path__ + "static/media/fluent-emoji-high-contrast_white-exclamation-mark.0b1a61ed2b18a30c0db0515995103c5d.svg";
export { ForwardRef as ReactComponent };